import { authGuard, guestGuard } from './utils'

export default [

    ...guestGuard([
        { path: '/login', name: 'login', component: () => import('@/pages/Login.vue') },
        { path: '/password/forgot', name: 'forgot-password', component: () => import('@/pages/ForgotPassword.vue') },
        { path: '/password/reset/:token', name: 'reset-password', component: () => import('@/pages/ResetPassword.vue') },
    ]),

    ...authGuard([
        { path: '/', name: 'welcome', component: () => import('@/pages/Welcome.vue')},
        { path: '/sandbox', name: 'sandbox', component: () => import('@/pages/Sandbox.vue')},

        { path: '/offers', name: 'offers', component: () => import('@/pages/offers/Offers.vue')},
        { path: '/offers/:slug/page/:page/:sort?/:order?/:search?', name: 'offers-subpages', component: () => import('@/pages/offers/Offers.vue')},
        { path: '/offer/create', name: 'offer-create', component: () => import('@/pages/Create.vue')},
        { path: '/offer/edit/:item/:slug', name: 'offer-edit', component: () => import('@/pages/offers/Offer.vue')},

        { path: '/stacked-offers', name: 'stacked-offers', component: () => import('@/pages/stackedoffers/StackedOffers.vue')},
        { path: '/stacked-offers/:slug/page/:page/:sort?/:order?/:search?', name: 'stacked-offers-subpages', component: () => import('@/pages/stackedoffers/StackedOffers.vue')},
        { path: '/stacked-offer/create', name: 'stacked-offer-create', component: () => import('@/pages/Create.vue')},
        { path: '/stacked-offer/edit/:item/:slug', name: 'stacked-offer-edit', component: () => import('@/pages/stackedoffers/StackedOffer.vue')},

        { path: '/landing-pages', name: 'landing-pages', component: () => import('@/pages/landingpages/LandingPages.vue')},
        { path: '/landing-pages/:slug/page/:page/:sort?/:order?/:search?', name: 'landing-pages-subpages', component: () => import('@/pages/landingpages/LandingPages.vue')},
        { path: '/landing-pages/create', name: 'landing-page-create', component: () => import('@/pages/Create.vue')},
        { path: '/landing-pages/edit/:item/:slug', name: 'landing-page-edit', component: () => import('@/pages/landingpages/LandingPage.vue')},

        { path: '/offer-sets', name: 'offer-sets', component: () => import('@/pages/Sandbox.vue')},
        { path: '/offer-sets/:slug', name: 'offer-sets-subpages', component: () => import('@/pages/Sandbox.vue')},
        { path: '/create-offer-set', name: 'offer-set-create', component: () => import('@/pages/Sandbox.vue')},
        { path: '/create-offer-set/:slug', name: 'offer-set-create-subpages', component: () => import('@/pages/Sandbox.vue')},

        { path: '/offers/new-offer', name: 'offer-new', component: () => import('@/pages/Sandbox.vue')},
        { path: '/offer-sets/new-offer-set', name: 'offer-set-new', component: () => import('@/pages/Sandbox.vue')},

        { path: '/quizzes', name: 'quizzes', component: () => import('@/pages/Sandbox.vue')},
        { path: '/quiz/create', name: 'quiz-create', component: () => import('@/pages/Create.vue')},
        { path: '/quiz/edit/:item/:slug', name: 'quiz-edit', component: () => import('@/pages/tools/quizzes/Edit.vue')},

        { path: '/co-regs', name: 'co-regs', component: () => import('@/pages/Sandbox.vue')},
        { path: '/quizzes/new-quiz', name: 'quiz-new', component: () => import('@/pages/Sandbox.vue')},
        { path: '/co-regs/new-co-reg', name: 'co-reg-new', component: () => import('@/pages/Sandbox.vue')},

        { path: '/clients', name: 'clients', component: () => import('@/pages/Sandbox.vue')},
        { path: '/clients/new-client', name: 'client-new', component: () => import('@/pages/Sandbox.vue')},
        { path: '/reports', name: 'reports', component: () => import('@/pages/Sandbox.vue')},

        { path: '/other-label', name: 'other-label', component: () => import('@/pages/Sandbox.vue')},
        { path: '/label-placeholder', name: 'label-placeholder', component: () => import('@/pages/Sandbox.vue')},
        { path: '/admin-users', name: 'admin-users', component: () => import('@/pages/Sandbox.vue')},
        { path: '/tracking-codes', name: 'tracking-codes', component: () => import('@/pages/global/TrackingCodes.vue')},

    ]),


    // 404
    // { path: '*', component: () => import('@/pages/NotFound.vue') },
]



// WEBPACK FOOTER //
// ./src/router/routes.js